import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    ButtonSecondary,
    HorizontalFlex,
    VerticalFlex,
    Input,
} from 'smartsuite-ui';
import ShareUrlCopyAlert from './ShareUrlCopyAlert';
import {
    fallbackCopyTextToClipboard,
    copyTextToClipboard,
} from './copyToClipboardUtil';
import { getShareInfo, shareSearchLink } from '../searchLinkUtils';

export default function ShareModal(props) {
    const params = useParams();
    const [shareableLink, setShareableLink] = useState('');
    const [isCopyingSuccessful, setIsCopyingSuccessful] = useState(false);
    const [hasCopyBeenClicked, setHasCopyBeenClicked] = useState(false);

    const onSendToClipboard = useCallback(async (link) => {
        const elementToCopyFrom = document.querySelector('#copyInput');
        elementToCopyFrom.focus();
        elementToCopyFrom.select();

        if (!navigator.clipboard) {
            const result = fallbackCopyTextToClipboard(elementToCopyFrom);
            setIsCopyingSuccessful(result);
            setHasCopyBeenClicked(true);
            return;
        }

        const navigatorResult = await copyTextToClipboard(link);
        setIsCopyingSuccessful(navigatorResult);
        setHasCopyBeenClicked(true);
    }, []);

    useEffect(() => {
        const { id, link } = getShareInfo(
            params.searchKey,
            props.uriConstants.getShareableUri
        );

        shareSearchLink(
            id,
            props.configurationForShare,
            props.uriConstants.saveSharedUrl
        )
            .then(
                () => setShareableLink(link),
                (error) => console.log(error) // eslint-disable-line no-console
            )
            .then(() => onSendToClipboard(link));
    }, [
        props.configurationForShare,
        params.searchKey,
        props.uriConstants,
        onSendToClipboard,
    ]);

    /* eslint-disable react/no-unknown-property */
    return (
        <Modal onOverlayClick={props.onDismiss}>
            <ModalHeader onDismiss={props.onDismiss}>
                ModalHeader Test
            </ModalHeader>
            <ModalBody>
                <VerticalFlex>
                    <HorizontalFlex cssClassModifiers={['align-flex-end']}>
                        <Input
                            id="copyInput"
                            cssClassModifiers={['small-relative']}
                            value={shareableLink}
                            contentEditable="true"
                            label="test label"
                            onChange={() => {}}
                        />
                        <Button
                            onClick={() => onSendToClipboard(shareableLink)}
                        >
                            translationLabels.copy Test
                        </Button>
                    </HorizontalFlex>
                    <ShareUrlCopyAlert
                        hasCopyBeenClicked={hasCopyBeenClicked}
                        isCopyingSuccessful={isCopyingSuccessful}
                        unappliedFiltersExist={props.unappliedFiltersExist}
                    />
                </VerticalFlex>
            </ModalBody>
            <ModalFooter>
                <HorizontalFlex cssClassModifiers={['justify-flex-end']}>
                    <ButtonSecondary onClick={props.onDismiss}>
                        translationLabels.close Test
                    </ButtonSecondary>
                </HorizontalFlex>
            </ModalFooter>
        </Modal>
    );
    /* eslint-disable react/no-unknown-property */
}

ShareModal.propTypes = {
    configurationForShare: PropTypes.instanceOf(Object).isRequired,
    onDismiss: PropTypes.func.isRequired,
    unappliedFiltersExist: PropTypes.bool.isRequired,
    uriConstants: PropTypes.instanceOf(Object).isRequired,
};
